import { ApiClient } from '../api-client';

/**
 *  NotificationApi is a singleton w/o interceptors(No Auth)
 * @returns {AxiosInstance}
 */
const NotificationApi = ApiClient.service.notification;

/**
 *  UseStoreApi is a hook that returns a reusable axios instance with auth
 * @returns {AxiosInstance}
 */
const useNotificationApi = () => {
  return NotificationApi;
};

export { NotificationApi, useNotificationApi };
